export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15105.1d32fec1.jpg";